import * as React from 'react';
import { InputControlContext } from '../common/input-control-context/input-control-context';
import { SingleValueComponent } from '../common';
import styles from './password.scss';
import { MdRemoveRedEye } from 'react-icons/md';
import { ButtonTertiary } from 'ui/common/button/button-tertiary';
import debounce from 'lodash/debounce';

const debounceTime = 500;

interface PasswordState {
  passwordShown: boolean;
  value: string;
  hasFocus?: boolean;
}

export class Password extends React.Component<SingleValueComponent<string>, PasswordState> {
  public state: Readonly<PasswordState> = {
    passwordShown: false,
    value: ''
  };

  private passwordInput: HTMLInputElement;
  private textInput: HTMLInputElement;

  private togglePasswordMask() {
    this.setState({ passwordShown: !this.state.passwordShown });
  }

  private debouncedOnChange: any = debounce((value) => {
    this.props.onChange(value);
  }, debounceTime);

  private onChange = () => {
    const newText = this.state.passwordShown ? this.textInput.value : this.passwordInput.value;
    this.setState({ value: newText });
    this.debouncedOnChange(newText);
  };

  private textFocus(): React.EventHandler<React.FocusEvent<HTMLInputElement>> {
    return () => this.setState({ hasFocus: true });
  }

  private textRef(): React.Ref<HTMLInputElement> {
    return input => this.textInput = input;
  }

  private passwordRef(): React.Ref<HTMLInputElement> {
    return input => this.passwordInput = input;
  }

  private passwordFocus(): React.EventHandler<React.FocusEvent<HTMLInputElement>> {
    return () => this.setState({ hasFocus: true });
  }

  private onBlur(): React.EventHandler<React.FocusEvent<HTMLInputElement>> {
    return () => this.setState({ hasFocus: false }, () => {
      this.props.onChange(this.state.value);
    });
  }

  public render() {
    const {
      placeholder
    } = this.props;
    const { passwordShown, value } = this.state;
    return (
      <InputControlContext
        {...this.props}>
        <div className={`${styles.wrapper} input-wrapper`}>
          <div className="input-group">
            <div className={`form-control ${this.state.hasFocus ? 'form-control-focus' : ''}`}>
              <input
                type="password"
                ref={this.passwordRef()}
                value={value}
                name={!passwordShown ? 'password' : ''}
                placeholder={placeholder}
                style={{ display: !passwordShown ? 'block' : 'none' }}
                onChange={this.onChange}
                onFocus={this.passwordFocus()}
                onBlur={this.onBlur()}
              />

              <input
                type="text"
                ref={this.textRef()}
                value={value}
                name={passwordShown ? 'passwordText' : ''}
                placeholder={placeholder}
                style={{ display: passwordShown ? 'block' : 'none' }}
                onChange={this.onChange}
                onFocus={this.textFocus()}
                onBlur={this.onBlur()}
              />

              <ButtonTertiary classNames={styles && styles.eyeIcon} onClick={this.eyeIconClick}>
                <MdRemoveRedEye size={20}/>
              </ButtonTertiary>
            </div>
          </div>
        </div>
      </InputControlContext>
    );
  }

  private eyeIconClick = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    return this.togglePasswordMask();
  };

}
